import type { PreviousApplication } from '../../shared/types';
import type { Dispatch, State } from '../use_candidate_profile';
import { AllApplicationsRightbar } from './layout_actions';

export const setInitalExpandedApplication =
  (state: State, dispatch: Dispatch) =>
  (applications: PreviousApplication[]) => {
    const { allApplicationsRightbar } = state;
    const expandedState = applications.reduce(
      (acc: AllApplicationsRightbar, curr) => {
        if (allApplicationsRightbar[curr.id] === undefined) {
          acc[curr.id] = curr.id === state.applicationId;
        }
        return acc;
      },
      {}
    );

    dispatch({
      type: 'setAllApplicationsRightbar',
      payload: expandedState,
    });
  };
